/* SOLE Find Your Machine quiz (sections/sole-machine-finder.liquid).
   Questions branch and skip themselves: a question is only asked when its answer would change the
   result. Weight is the one HARD filter (never recommend a machine rated below the user); use, screen
   and budget only RANK, so every path ends in real, buyable picks.
   Presentation: one question at a time on a charcoal stage, direction-aware slide between steps, a
   photo panel that follows the answers, and a live "N machines fit" strip. All motion is skipped under
   prefers-reduced-motion.
   Privacy: the weight answer never goes into the URL or analytics. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fym]');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('[data-fym-data]').textContent); } catch (e) { return; }

  var ALL = data.machines.filter(function (m) { return m.available; });
  ALL.forEach(function (m, i) {
    m.rank = i;
    m.uses = (m.uses || []).map(function (u) { return String(u).trim(); }).filter(Boolean);
  });

  var $ = function (sel) { return root.querySelector(sel); };
  var stage = $('[data-fym-stage]');
  var quiz = $('[data-fym-quiz]');
  var results = $('[data-fym-results]');
  var backBtn = $('[data-fym-back]');
  var segs = $('[data-fym-segs]');
  var count = $('[data-fym-count]');
  var dots = $('[data-fym-dots]');
  var matches = $('[data-fym-matches]');
  var live = $('[data-fym-live]');
  var photos = root.querySelectorAll('[data-fym-photo]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ORDER = ['kind', 'low', 'posture', 'use_treadmill', 'use_elliptical', 'use_bike', 'screen', 'weight', 'budget'];
  var KINDS = ['treadmill', 'manual', 'elliptical', 'climber', 'bike', 'rower'];
  var BANDS = { b1: [0, 110000], b2: [110000, 150000], b3: [150000, 200000], b4: [200000, Infinity] };
  var PLURAL = { treadmill: 'treadmills', manual: 'manual treadmills', elliptical: 'ellipticals', climber: 'cardio climbers', bike: 'exercise bikes', rower: 'rowers' };
  var USE_LABEL = { walk: 'walking', jog: 'jogging', run: 'serious running and shared use', solo: 'one main user', shared: 'several users of different heights', intense: 'serious daily training', upright: 'upright riding', recumbent: 'recumbent riding with back support' };
  /* Where to look when a type has only one model, so a result is never a lone card. */
  var RELATED = { manual: ['treadmill', 'run'], rower: ['climber', null], climber: ['rower', null], recumbent: ['bike', 'upright'] };
  /* When no machine of the chosen type is rated for the user, lead with the closest type that is. */
  var PIVOT = { manual: 'treadmill', treadmill: 'elliptical', bike: 'elliptical', elliptical: 'climber' };
  /* Photo shown for a type before a more specific answer picks one. */
  var KIND_PHOTO = { treadmill: 'f80', manual: 'c80', elliptical: 'e95', climber: 'cc81', bike: 'lcr', rower: 'sr550' };

  var s = {};
  var trail = [];
  var current = null;
  var busy = false;

  function track(event, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      for (var k in params) payload[k] = params[k];
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break the quiz */ }
  }

  function kindOf(st) {
    if (st.kind !== 'unsure') return st.kind || null;
    if (st.low === 'no') return 'treadmill';
    if (st.low === 'yes') return st.posture === 'seated' ? 'bike' : st.posture === 'standing' ? 'elliptical' : null;
    return null;
  }

  function bandOf(price) {
    for (var b in BANDS) if (price >= BANDS[b][0] && price < BANDS[b][1]) return b;
    return null;
  }

  function weightNeed(st) { return st.weight && st.weight !== 'skip' ? Number(st.weight) : 0; }

  /* Machines still in play. use narrows softly (falls back when nothing matches). */
  function pool(st, opts) {
    var k = kindOf(st);
    var list = k ? ALL.filter(function (m) { return m.kind === k; }) : ALL.slice();
    if (st.kind === 'unsure' && !k && st.low === 'yes') list = ALL.filter(function (m) { return m.kind === 'elliptical' || m.kind === 'bike'; });
    if (opts && opts.use && st.use) {
      var byUse = list.filter(function (m) { return m.uses.indexOf(st.use) !== -1; });
      if (byUse.length) list = byUse;
    }
    if (opts && opts.weight && weightNeed(st)) {
      list = list.filter(function (m) { return m.maxLb >= weightNeed(st); });
    }
    return list;
  }

  /* What the live strip counts: every answer so far applied as a filter, each one skipped if it would
     empty the set. Honest narrowing, never "0 machines". */
  function fitSet(st) {
    var list = pool(st, { use: true });
    function narrow(fn) { var n = list.filter(fn); if (n.length) list = n; }
    if (weightNeed(st)) narrow(function (m) { return m.maxLb >= weightNeed(st); });
    if (st.screen === 'touch') narrow(function (m) { return m.screen === 'touch'; });
    if (st.screen === 'tablet') narrow(function (m) { return m.tablet; });
    if (st.screen === 'basic') narrow(function (m) { return m.screen === 'basic'; });
    if (st.budget && BANDS[st.budget]) narrow(function (m) { return m.price < BANDS[st.budget][1]; });
    return list;
  }

  function distinct(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }

  var ASK = {
    kind: function () { return true; },
    low: function (st) { return st.kind === 'unsure'; },
    posture: function (st) { return st.kind === 'unsure' && st.low === 'yes'; },
    use_treadmill: function (st) { return kindOf(st) === 'treadmill'; },
    use_elliptical: function (st) { return kindOf(st) === 'elliptical'; },
    use_bike: function (st) { return kindOf(st) === 'bike'; },
    screen: function (st) {
      if (st.kind === 'unsure' && !kindOf(st)) return true;
      return distinct(pool(st, { use: true }).map(function (m) { return m.screen; })).length > 1;
    },
    weight: function (st) {
      if (st.kind === 'unsure' && !kindOf(st)) return true;
      return pool(st, { use: true }).some(function (m) { return m.maxLb < 400; });
    },
    budget: function (st) {
      if (st.kind === 'unsure' && !kindOf(st)) return true;
      var l = pool(st, { use: true, weight: true });
      if (!l.length) return false;
      return distinct(l.map(function (m) { return bandOf(m.price); })).length > 1;
    }
  };

  function nextAfter(stepId, st) {
    var i = stepId ? ORDER.indexOf(stepId) + 1 : 0;
    for (; i < ORDER.length; i++) if (ASK[ORDER[i]](st)) return ORDER[i];
    return null;
  }

  function remaining(stepId, st) {
    var n = 0, id = stepId;
    while (id) { n++; id = nextAfter(id, st); }
    /* Before the type is known no use_* step can qualify yet, but most paths will ask one. */
    if (!kindOf(st) && st.kind !== 'manual' && st.kind !== 'rower' && st.kind !== 'climber') n++;
    return n;
  }

  function keyFor(id) { return id.indexOf('use_') === 0 ? 'use' : id; }
  function stepEl(id) { return quiz.querySelector('[data-step="' + id + '"]'); }

  /* ---------- presentation ---------- */

  var panel = root.querySelector('.sole-fym__photo');
  function fileOf(u) { return String(u || '').split('?')[0].split('/').pop(); }

  function setPhoto(code) {
    var url = code && data.photos[code];
    if (!url || !photos.length) return;
    /* The panel is desktop-only: never download a photo nobody can see. */
    if (!panel || window.getComputedStyle(panel).display === 'none') return;
    var on = photos[0].classList.contains('is-on') ? photos[0] : photos[1];
    /* The first photo arrives through a <picture>, so compare what is actually showing. */
    if (fileOf(on.currentSrc || on.getAttribute('src')) === fileOf(url)) return;
    var off = on === photos[0] ? photos[1] : photos[0];
    off.onload = function () { off.classList.add('is-on'); on.classList.remove('is-on'); };
    off.setAttribute('src', url);
  }

  function photoFor(st) {
    var k = kindOf(st);
    if (st.use) {
      var btn = quiz.querySelector('[data-step^="use_"] [data-value="' + st.use + '"][data-photo]');
      if (btn) return btn.getAttribute('data-photo');
    }
    if (k) return KIND_PHOTO[k];
    if (st.low === 'yes') return 'e25';
    return null;
  }

  function buildDots() {
    dots.innerHTML = ALL.map(function (m) {
      return '<li data-code="' + esc(m.code) + '"><img src="' + esc(m.thumb) + '" alt="" width="96" height="96" loading="lazy"><span>' + esc(m.code) + '</span></li>';
    }).join('');
  }

  /* Mini cards fade out as answers rule machines out, then leave the row so the rest close up. */
  function updateMatches() {
    var fit = fitSet(s);
    var codes = fit.map(function (m) { return m.code; });
    matches.hidden = trail.length === 0;
    dots.querySelectorAll('li').forEach(function (d) {
      var keep = codes.indexOf(d.getAttribute('data-code')) !== -1;
      clearTimeout(d._fymT);
      if (keep) {
        d.hidden = false;
        requestAnimationFrame(function () { d.classList.remove('is-out'); });
      } else if (!d.hidden) {
        d.classList.add('is-out');
        if (reduced || matches.hidden) d.hidden = true;
        else d._fymT = setTimeout(function () { d.hidden = true; }, 280);
      }
    });
    live.textContent = fit.length + (fit.length === 1 ? ' machine fits' : ' machines fit') + ' so far';
  }

  function renderProgress(id) {
    var done = trail.length;
    var total = done + remaining(id, s);
    count.textContent = 'Step ' + (done + 1) + ' of ' + total;
    var html = '';
    for (var i = 0; i < total; i++) html += '<i' + (i < done ? ' class="is-done"' : '') + '></i>';
    segs.innerHTML = html;
  }

  function show(id, focus, dir) {
    var prevId = current;
    current = id;
    root.setAttribute('data-dir', dir || 'fwd');
    root.classList.toggle('is-started', trail.length > 0);
    stage.hidden = false;
    quiz.hidden = false;
    results.hidden = true;
    renderProgress(id);
    backBtn.hidden = trail.length === 0;
    var key = keyFor(id);
    stepEl(id).querySelectorAll('.sole-fym__opt').forEach(function (b) {
      b.setAttribute('aria-pressed', String(s[key] === b.getAttribute('data-value')));
    });
    updateMatches();
    setPhoto(photoFor(s));

    var incoming = stepEl(id);
    var outgoing = prevId && prevId !== id ? stepEl(prevId) : null;
    function enter() {
      ORDER.forEach(function (sid) { var el = stepEl(sid); el.hidden = sid !== id; el.classList.remove('is-leaving'); });
      /* restart the entry animation even when the same step is shown again */
      incoming.style.animation = 'none'; void incoming.offsetWidth; incoming.style.animation = '';
      busy = false;
      if (focus) {
        incoming.querySelector('.sole-fym__q').focus({ preventScroll: true });
        var top = stage.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.5) stage.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
    if (outgoing && !outgoing.hidden && !reduced) {
      busy = true;
      outgoing.classList.add('is-leaving');
      setTimeout(enter, 160);
    } else {
      enter();
    }
  }

  /* Changing an answer invalidates everything after it. */
  function clearAfter(id) {
    var i = ORDER.indexOf(id);
    ORDER.slice(i + 1).forEach(function (sid) { delete s[keyFor(sid)]; });
  }

  function answer(id, value) {
    var key = keyFor(id);
    if (s[key] !== value) clearAfter(id);
    s[key] = value;
    track('finder_answer', { finder_step: id, finder_value: id === 'weight' ? (value === 'skip' ? 'skipped' : 'answered') : value });
    trail.push(id);
    var nxt = nextAfter(id, s);
    if (nxt) show(nxt, true, 'fwd'); else showResults(true);
  }

  function back() {
    if (busy) return;
    var prev = trail.pop();
    if (prev) show(prev, true, 'back');
  }

  function goTo(id) {
    var at = trail.indexOf(id);
    if (at === -1) return;
    trail = trail.slice(0, at);
    current = null;
    show(id, true, 'back');
  }

  /* ---------- matching ---------- */

  function score(m, st) {
    var sc = 0, why = [], trade = [];
    if (st.use) {
      var at = m.uses.indexOf(st.use);
      if (at !== -1) { sc += at === 0 ? 5 : 4; why.push('A good fit for ' + USE_LABEL[st.use]); }
    }
    if (st.screen === 'touch') {
      if (m.screen === 'touch') { sc += 3; why.push('Built-in touchscreen'); } else trade.push('No built-in touchscreen');
    } else if (st.screen === 'tablet') {
      if (m.tablet) { sc += m.screen === 'basic' ? 3 : 2; why.push('Holds your tablet'); } else trade.push('No tablet holder');
    } else if (st.screen === 'basic') {
      if (m.screen === 'basic') { sc += 3; why.push('Simple display'); } else { sc += 1; trade.push('Adds a touchscreen'); }
    }
    if (weightNeed(st)) why.push('Rated to ' + m.maxLb + ' lb');
    if (st.budget && st.budget !== 'any') {
      var b = BANDS[st.budget];
      if (m.price >= b[0] && m.price < b[1]) { sc += 3; why.push('In your budget'); }
      else if (m.price < b[0]) { sc += 2; why.push('Under your budget'); }
      else trade.push('Above your budget');
    }
    return { m: m, score: sc, why: why, trade: trade };
  }

  function rankList(list, st) {
    return list.map(function (m) { return score(m, st); })
      .sort(function (a, b) { return b.score - a.score || a.m.rank - b.m.rank; });
  }

  function computeResults(st) {
    var k = kindOf(st);
    var need = weightNeed(st);
    var kindList = pool(st, {});
    var ok = kindList.filter(function (m) { return m.maxLb >= need; });
    var picks, alt = null;

    if (!ok.length && need) {
      var top = Math.max.apply(null, kindList.map(function (m) { return m.maxLb; }));
      var pref = PIVOT[k];
      picks = rankList(ALL.filter(function (m) { return m.maxLb >= need; }), { screen: st.screen, budget: st.budget, weight: st.weight })
        .sort(function (a, b) { return (a.m.kind === pref ? 0 : 1) - (b.m.kind === pref ? 0 : 1); })
        .slice(0, 3);
      return { picks: picks, alt: null, pivot: true, note: 'None of our ' + (PLURAL[k] || 'machines') + ' is rated above ' + top + ' lb, so here are the closest machines rated for that weight.' };
    }

    var ranked = rankList(ok, st);
    var rest = [];
    if (st.use) {
      var matched = ranked.filter(function (r) { return r.m.uses.indexOf(st.use) !== -1; });
      if (matched.length) {
        rest = ranked.filter(function (r) { return matched.indexOf(r) === -1; });
        ranked = matched;
      }
    }
    picks = ranked.slice(0, 3);

    /* The weight filter can leave one model for a use. Offer the next-best model of the same type
       before reaching into a related type. */
    if (picks.length === 1 && rest.length) {
      alt = rest[0];
    } else if (picks.length === 1) {
      var rel = RELATED[st.use === 'recumbent' ? 'recumbent' : k];
      if (rel) {
        var relSt = { use: rel[1], screen: st.screen, budget: st.budget, weight: st.weight };
        var relList = ALL.filter(function (m) { return m.kind === rel[0] && m.maxLb >= need && m !== picks[0].m; });
        if (rel[1]) {
          var relUse = relList.filter(function (m) { return m.uses.indexOf(rel[1]) !== -1; });
          if (relUse.length) relList = relUse;
        }
        alt = rankList(relList, relSt)[0] || null;
      }
    }
    var exact = picks.length && !picks[0].trade.length;
    return { picks: picks, alt: alt, pivot: false, note: exact ? '' : 'No exact match, so here is your closest fit and what you would trade off.' };
  }

  /* ---------- results ---------- */

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var d = Math.abs(cents) / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function priceHtml(m) {
    return esc(m.priceFmt) + (m.compareFmt ? ' <s><span class="sole-fym__sr">Was </span>' + esc(m.compareFmt) + '</s>' : '');
  }

  function whyList(r) {
    var lis = r.why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') +
      r.trade.map(function (t) { return '<li class="is-trade">' + esc(t) + '</li>'; }).join('');
    return lis ? '<ul class="sole-fym__why">' + lis + '</ul>' : '';
  }

  /* "Why this over that", built only from price, screen and weight rating. */
  function diffLine(a, best) {
    var parts = [];
    var d = a.price - best.price;
    if (d < 0) parts.push(money(d) + ' less than the ' + best.code);
    else if (d > 0) parts.push(money(d) + ' more than the ' + best.code);
    if (a.screen !== best.screen) parts.push(a.screen === 'touch' ? 'Adds a built-in touchscreen' : 'Simple display instead of a touchscreen');
    if (a.maxLb > best.maxLb) parts.push('Rated to ' + a.maxLb + ' lb');
    return parts.join('. ') + (parts.length ? '.' : '');
  }

  function heroHtml(r, note) {
    var m = r.m;
    var img = m.life
      ? '<img src="' + esc(m.life) + '" alt="" width="900" height="600">'
      : '<img class="is-cutout" src="' + esc(m.img) + '" alt="" width="480" height="480">';
    return '<article class="sole-fym__hero">' +
      '<div class="sole-fym__hero-media">' + img + '<span class="sole-fym__badge">Best match</span></div>' +
      '<div class="sole-fym__hero-body">' +
        '<p class="sole-fym__price">' + priceHtml(m) + '</p>' +
        (m.chips ? '<p class="sole-fym__specs">' + esc(m.chips) + '</p>' : '') +
        (note ? '<p class="sole-fym__specs">' + esc(note) + '</p>' : '') +
        whyList(r) +
        '<a class="sole-fym__cta" href="' + esc(m.url) + '" data-fym-pick="' + esc(m.code) + '" data-fym-rank="1">View the ' + esc(m.code) + '</a>' +
      '</div></article>';
  }

  function altHtml(r, i, best, tag) {
    var m = r.m;
    return '<article class="sole-fym__alt">' +
      '<div class="sole-fym__alt-media"><img src="' + esc(m.img) + '" alt="" loading="lazy" width="240" height="240"></div>' +
      '<div>' +
        '<p class="sole-fym__alt-tag">' + tag + '</p>' +
        '<h3 class="sole-fym__alt-name">' + esc(m.name) + '</h3>' +
        '<p class="sole-fym__alt-price">' + priceHtml(m) + '</p>' +
        '<p class="sole-fym__alt-diff">' + esc(diffLine(m, best)) + '</p>' +
        '<a class="sole-fym__alt-link" href="' + esc(m.url) + '" data-fym-pick="' + esc(m.code) + '" data-fym-rank="' + (i + 1) + '">View the ' + esc(m.code) + '</a>' +
      '</div></article>';
  }

  function answerLabel(id) {
    var v = s[keyFor(id)];
    if (id === 'weight' && v === 'skip') return 'Weight skipped';
    var lbl = stepEl(id).querySelector('[data-value="' + v + '"] .sole-fym__label');
    return lbl ? lbl.textContent : v;
  }

  function subline(r) {
    var bits = [];
    if (s.use) bits.push('for ' + USE_LABEL[s.use]);
    if (r.why.indexOf('Built-in touchscreen') !== -1) bits.push('with a built-in touchscreen');
    if (r.why.indexOf('Holds your tablet') !== -1) bits.push('with a place for your tablet');
    if (r.why.indexOf('In your budget') !== -1 || r.why.indexOf('Under your budget') !== -1) bits.push('within your budget');
    if (!bits.length) return '';
    var t = bits.join(', ');
    return 'Picked ' + t + '.';
  }

  function renderResults() {
    var out = computeResults(s);
    var best = out.picks[0];
    $('[data-fym-rh]').textContent = best.m.name;
    $('[data-fym-rsub]').textContent = out.pivot ? out.note : subline(best);
    $('[data-fym-answers]').innerHTML = trail.map(function (id) {
      var q = stepEl(id).querySelector('.sole-fym__q').textContent;
      return '<li><button type="button" data-fym-edit="' + id + '" aria-label="Change your answer to: ' + esc(q) + ' Current answer: ' + esc(answerLabel(id)) + '">' +
        esc(answerLabel(id)) + ' <span>Edit</span></button></li>';
    }).join('');
    $('[data-fym-hero]').innerHTML = heroHtml(best, out.pivot ? '' : out.note);
    var alts = out.picks.slice(1).map(function (r, i) { return altHtml(r, i + 1, best.m, 'Runner-up'); });
    if (out.alt) alts.push(altHtml(out.alt, out.picks.length, best.m, 'Also consider'));
    $('[data-fym-alts]').innerHTML = alts.join('');
    var k = kindOf(s);
    var all = $('[data-fym-all]');
    if (k && data.collections[k]) { all.href = data.collections[k]; all.textContent = 'See all ' + PLURAL[k]; }
    track('finder_complete', {
      finder_type: k || 'unsure',
      finder_picks: out.picks.map(function (r) { return r.m.code; }).join(',')
    });
    return out;
  }

  function showResults(focus) {
    current = null;
    busy = false;
    stage.hidden = true;
    results.hidden = false;
    var matching = $('[data-fym-matching]');
    var wrap = $('[data-fym-rwrap]');
    renderResults();
    writeUrl();
    function reveal() {
      matching.hidden = true;
      wrap.hidden = false;
      if (focus) $('[data-fym-rh]').focus({ preventScroll: true });
      results.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    if (focus && !reduced) {
      var n = fitSet(s).length;
      $('[data-fym-matching-text]').textContent = 'Matching you with ' + n + ' of ' + ALL.length + ' machines…';
      wrap.hidden = true;
      matching.hidden = false;
      results.scrollIntoView({ behavior: 'auto', block: 'start' });
      setTimeout(reveal, 650);
    } else {
      reveal();
    }
  }

  /* Shareable results: type/use/screen/budget only. Weight is deliberately left out. */
  var URL_KEYS = ['type', 'use', 'screen', 'budget'];

  function writeUrl() {
    try {
      var u = new URL(window.location.href);
      URL_KEYS.forEach(function (p) { u.searchParams.delete(p); });
      var k = kindOf(s);
      if (k) u.searchParams.set('type', k);
      ['use', 'screen', 'budget'].forEach(function (p) { if (s[p]) u.searchParams.set(p, s[p]); });
      window.history.replaceState(null, '', u.toString());
    } catch (e) { /* old browsers: results still work, just not shareable */ }
  }

  function clearUrl() {
    try {
      var u = new URL(window.location.href);
      URL_KEYS.forEach(function (p) { u.searchParams.delete(p); });
      window.history.replaceState(null, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  function start() {
    s = {};
    trail = [];
    buildDots();
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { params = null; }
    var type = params && params.get('type');
    if (type && KINDS.indexOf(type) !== -1) {
      s.kind = type;
      trail.push('kind');
      ['use', 'screen', 'budget'].forEach(function (p) { var v = params.get(p); if (v) s[p] = v; });
      if (s.use || s.screen || s.budget) {
        /* A shared results link: rebuild the path the visitor took so Edit and Back still work. */
        var id = nextAfter('kind', s);
        while (id && s[keyFor(id)]) { trail.push(id); id = nextAfter(id, s); }
        if (!id) { showResults(false); return; }
        show(id, false);
        return;
      }
      show(nextAfter('kind', s) || 'kind', false);
      return;
    }
    show('kind', false);
  }

  /* ---------- events ---------- */

  quiz.addEventListener('click', function (e) {
    var btn = e.target.closest('.sole-fym__opt, .sole-fym__skip');
    if (!btn || !current || busy) return;
    var id = current;
    var value = btn.getAttribute('data-value') || btn.getAttribute('data-skip');
    if (!trail.length && id === 'kind') track('finder_start', {});
    busy = true;
    stepEl(id).querySelectorAll('.sole-fym__opt').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    var ph = btn.getAttribute('data-photo');
    if (ph) setPhoto(ph);
    /* Let the selected state register before the step moves on. */
    setTimeout(function () { busy = false; answer(id, value); }, reduced ? 0 : 240);
  });

  /* Preview the matching photo while choosing (pointer devices only). */
  quiz.addEventListener('mouseover', function (e) {
    var btn = e.target.closest('[data-photo]');
    if (btn && window.matchMedia('(hover: hover)').matches) setPhoto(btn.getAttribute('data-photo'));
  });

  /* Arrow keys move between answers; number keys pick one. */
  quiz.addEventListener('keydown', function (e) {
    if (!current) return;
    var opts = Array.prototype.slice.call(stepEl(current).querySelectorAll('.sole-fym__opt'));
    var i = opts.indexOf(document.activeElement);
    if (/^[1-9]$/.test(e.key) && !e.altKey && !e.ctrlKey && !e.metaKey) {
      var o = opts[Number(e.key) - 1];
      if (o) { e.preventDefault(); o.click(); }
      return;
    }
    if (i === -1) return;
    var move = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
    if (move) { e.preventDefault(); opts[(i + move + opts.length) % opts.length].focus(); }
  });

  backBtn.addEventListener('click', back);

  results.addEventListener('click', function (e) {
    var edit = e.target.closest('[data-fym-edit]');
    if (edit) { goTo(edit.getAttribute('data-fym-edit')); return; }
    if (e.target.closest('[data-fym-retake]')) {
      clearUrl();
      s = {};
      trail = [];
      current = null;
      track('finder_retake', {});
      show('kind', true, 'back');
      return;
    }
    var a = e.target.closest('[data-fym-pick]');
    if (!a) return;
    var code = a.getAttribute('data-fym-pick');
    track('finder_result_click', { finder_model: code, finder_rank: Number(a.getAttribute('data-fym-rank')) });
    /* Order attribution: Shopify reads `_finder` on the order (GA4 purchase counts are not trusted). */
    try {
      fetch('/cart/update.js', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _finder: code } })
      });
    } catch (err) { /* never block the navigation */ }
  });

  start();
})();
